import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IMarketingRequest } from '../models/marketing-options.model';

export const loadMarketingOptions = createAction('[MarketingOptions] Load MarketingOptions', props<{ request: IMarketingRequest }>());

export const loadMarketingOptionsSuccess = createAction('[MarketingOptions] Load MarketingOptions Success', props<{ response: any }>());

export const loadMarketingOptionsFailure = createAction(
  '[MarketingOptions] Load MarketingOptions Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
